<section class="asic-invoice-page d-flex flex-column">
  <header class="header d-flex align-items-center justify-content-between gap-4 border-bottom">
    <app-page-title
      header="ASIC Invoice"
      iconClass="ic-documents-20"
    />

    <div class="controls pr-4 d-flex align-items-center gap-8">
      <button
        data-id="asic-invoice-page_send-email-button"
        type="button"
        class="btn btn-primary d-flex align-items-center gap-2"
        [disabled]="isLoading() || form.invalid || !form.controls.emails.value.length"
        (click)="sendEmail()"
      >
        <span>Send email</span>
        <i class="icon ic-arrow-right-20"></i>
      </button>
    </div>
  </header>

  <div class="page-content flex-grow-1 d-flex align-items-stretch" [class.sidebar-collapsed]="isSidebarCollapsed()">
    <aside class="sidebar-container">
      <div class="sidebar">
        <div class="p-4 border-bottom">
          @if (document) {
            <div class="mb-4">
              <app-ag-tag-entity-title
                [isLink]="true"
                [entity]="document.company"
                [entityType]="entityType"
              />
            </div>
          }

          <div>
            <ul class="invoice-status-elements list-unstyled mb-0">
              <li>
                <div class="title">Date Created</div>
                <div class="value">{{ document?.createdOn | date: 'dd MMM yyyy' }}</div>
              </li>

              <!-- <li class="full-width-grid-row"> -->
              <li>
                <div class="title">Tags</div>
                <div class="value">
                  @for (tag of document?.company?.tags; track $index) {
                    <app-tag [tag]="tag"/>
                  } @empty {
                    N/A
                  }
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="uploaded-container border-bottom p-4 d-flex flex-column gap-3">
          <div class="d-flex justify-content-between align-items-center gap-4">
            <div class="title-wrapper d-flex gap-12">
              <div>
                <i class="icon ic-documents-20"></i>
              </div>

              <div class="font-size-16 font-weight-600 line-height-16">Documents</div>
            </div>

            <div
              ngbDropdown
              class="dropdown"
              [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
            >
              <button
                ngbDropdownToggle
                type="button"
                class="btn btn-secondary btn-icon"
              >
                <i class="icon ic-download-20"></i>
              </button>
              <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
                <div
                  ngbDropdownItem
                  (click)="downloadCombinedPDF(DocumentSubFolderName.Final)"
                >
                  <span>Download combined PDF</span>
                </div>

                <div
                  ngbDropdownItem
                  (click)="downloadZIP(DocumentSubFolderName.Final)"
                >
                  <span>Download ZIP</span>
                </div>
              </div>
            </div>
          </div>

          @if (files?.original?.length) {
            <div class="original-docs">
              <app-documents-list-accordion
                label="Original"
                noDocsPlaceholder="No original documents"
                [initialClosed]="false"
                [hideDeleteBtn]="true"
                [documents]="files?.original ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Original)"
              />
            </div>
          }

          @if (files?.attached?.length) {
            <div class="uploaded-docs">
              <app-documents-list-accordion
                label="Attached"
                noDocsPlaceholder="No uploaded files"
                [initialClosed]="!files?.attached?.length"
                [documents]="files?.attached ?? null"
                (deleteFile)="deleteFile($event.name)"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Upload)"
              />
            </div>
          }

          <button
            type="button"
            class="btn btn-primary w-100"
            (click)="openUploadFileModal(DocumentSubFolderName.FileAttached)"
          >
              Upload File(s)
          </button>
        </div>
      </div>
    </aside>

    <div class="content-wrapper position-relative flex-grow-1 p-3 border-left" [class.ml-3]="isSidebarCollapsed()">
      <button
        type="button"
        class="btn btn-secondary btn-icon sidebar-switch-btn"
        (click)="isSidebarCollapsed.set(!isSidebarCollapsed())"
      >
        <i
          class="icon"
          [class]="{
            'ic-arrow-left-20': !isSidebarCollapsed(),
            'ic-arrow-right-20': isSidebarCollapsed()
          }"
        ></i>
      </button>

      <div class="content">
        @if (isLoading()) {
          <app-loader/>
        } @else {
          <div [formGroup]="form">

            @if (successMessage) {
              <div class="msg-container success">
                <div class="icon-container">
                  <i class="icon ic-checkmark-circle-16"></i>
                </div>

                <div>{{ successMessage }}</div>
              </div>
            }

            <div class="form-group">
              <app-multiple-input-email
                label="To"
                placeholder="Enter email"
                formControlName="emails"
              />
            </div>

            <div class="form-group">
              <app-checkbox
                label="I want to attach the uploaded documents to the email"
                formControlName="includeAttachedFiles"
              />
            </div>
          </div>

          @if (document) {
            <app-email-preview
              [documentBase]="document"
              [sendByMethod]="sendOptionEmail"
              [isDocument]="true"
              (changeEmail)="onChangeEmail($event)"
            />
          }
        }
      </div>
    </div>
  </div>
</section>
